import React from 'react';
import { X } from 'lucide-react';

/**
 * HtmlModuleFrame
 *
 * Generic wrapper that hosts a self-contained module HTML file (in
 * /public/modules) inside a full-screen iframe with a single floating exit
 * button. Used by every drill/module hub so we don't repeat wrapper code.
 */
const HtmlModuleFrame = ({ src, title, onExit, testId = 'html-module' }) => (
  <div className="fixed inset-0 bg-[#1A1A1A] z-40 flex flex-col" data-testid={testId}>
    <button
      onClick={onExit}
      aria-label={title ? `Exit ${title}` : 'Exit module'}
      data-testid={`${testId}-exit`}
        className="absolute top-safe-3 right-3 z-50 w-9 h-9 rounded-full bg-[#1A1A1A]/80 border border-[#F5F2EB]/15 text-[#F5F2EB]/70 hover:text-[#F5F2EB] hover:border-[#F5F2EB]/35 backdrop-blur flex items-center justify-center transition-colors"
    >
      <X className="w-4 h-4" />
    </button>
    <iframe
      src={src}
      title={title || 'Module'}
      className="flex-1 w-full border-0"
      allow="microphone; autoplay; fullscreen; encrypted-media"
    />
  </div>
);

export default HtmlModuleFrame;
